export default __webpack_public_path__ + "6d5a8c60f08d03bec9a008c6e2b577a9.png";